import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { useTenantStore } from "../../stores/tenant";
import { useToastStore } from "../../stores/toast";
import { Badge } from "../../components/ui/badge";

const TYPES = [
  { value: "restaurant", label: "Restaurant" },
  { value: "garage", label: "Garage" },
  { value: "velo", label: "Atelier vélo" },
  { value: "salon", label: "Salon / Coiffeur / Bien-être" },
  { value: "consulting", label: "Consultation / Agence B2B" },
  { value: "custom", label: "Autre / sur mesure" },
] as const;

export function TenantsList() {
  const tenants = useTenantStore((s) => s.available);
  const loadAvailable = useTenantStore((s) => s.loadAvailable);
  const setTenant = useTenantStore((s) => s.setTenant);
  const push = useToastStore((s) => s.push);

  const [name, setName] = useState("");
  const [type, setType] = useState<(typeof TYPES)[number]["value"]>("restaurant");
  const [greeting, setGreeting] = useState("");
  const [saving, setSaving] = useState(false);

  const create = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || saving) return;
    setSaving(true);
    try {
      const created = await api<{ id: string }>("/api/tenants", {
        method: "POST",
        body: JSON.stringify({
          name: name.trim(),
          type,
          ...(greeting.trim() ? { greetingMessage: greeting.trim() } : {}),
        }),
      });
      setName("");
      setGreeting("");
      push("success", "Établissement créé");
      await loadAvailable();
      if (created?.id) setTenant(created.id);
    } catch {
      push("danger", "Échec de la création (réservé aux admins)");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <header className="page-header">
        <div className="page-header__titles">
          <h1 className="page-header__title">Établissements</h1>
          <p className="page-header__subtitle">
            Chaque établissement a son numéro, sa voix, ses horaires et son métier.
          </p>
        </div>
      </header>
      <form className="config-form" onSubmit={create}>
        <input
          className="input"
          type="text"
          placeholder="Nom (ex : Bistro Démo)"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <select className="select" value={type} onChange={(e) => setType(e.target.value as typeof type)}>
          {TYPES.map((t) => (
            <option key={t.value} value={t.value}>{t.label}</option>
          ))}
        </select>
        <input
          className="input config-form__grow"
          type="text"
          placeholder="Message d'accueil (optionnel)"
          value={greeting}
          onChange={(e) => setGreeting(e.target.value)}
        />
        <button type="submit" className="btn btn--primary" disabled={saving || !name.trim()}>
          {saving ? "Création…" : "Créer"}
        </button>
      </form>

      <table className="table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Type</th>
            <th>Langue</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {tenants.length === 0 ? (
            <tr><td colSpan={4} className="table__empty">Aucun établissement — crées-en un ci-dessus.</td></tr>
          ) : (
            tenants.map((t) => (
              <tr key={t.id}>
                <td>{t.name}</td>
                <td><Badge variant="primary">{t.type}</Badge></td>
                <td>{t.language}</td>
                <td className="table__actions">
                  <Link to={`/tenants/${t.id}/settings`}>Configurer</Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
